import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { GTM } from 'lib/core/services/gtm'
import { useCoreContext } from 'lib/core/hooks'
import { fetchProduct } from 'lib/modules/catalog'
import { getProductAttributeList } from 'lib/core/data/common/productAttributeList/selectors'
import { RootState } from 'lib/core/data/reducer'
import { Ga4Events } from '../../../../gtm/index'

interface Params {
  sku?: string
  enableGTM?: boolean
}

export const useProductBySku = (params?: Params) => {
  const { magentoClient } = useCoreContext()
  const productAttrList = useSelector(getProductAttributeList)
  const storeConfig = useSelector((state: RootState) => state.common.storeConfig.payload)
  const enableGTM = params?.enableGTM

  const { isError, isFetching, isLoading, data: product } = useQuery(
    ['useProductsBySku', params?.sku], async () => {
      return fetchProduct({
        sku: params?.sku,
        magentoClient,
        productAttrList,
        storeConfig
      })
    }, {
      enabled: Boolean(params?.sku)
    }
  )

  useEffect(() => {
    if (product && enableGTM) {
      GTM.productDetail({
        product
      })
      Ga4Events.viewItem({ product })
    }
  }, [product, enableGTM])

  return {
    isError,
    isFetching,
    isLoading,
    product
  }
}
